/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ProgramTypeEnum,
  ProgramTypeEnumOptional,
  ProgramTypeEnumMetaI,
  ProgramTypeEnumTrackedI,
} from "./program-type-enum";
import {
  ProgramTypeEnumTracked,
  ProgramTypeEnumMeta,
} from "./program-type-enum";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportDTO,
  ReportDTOOptional,
  ReportDTOMetaI,
  ReportDTOTrackedI,
} from "./report-dto";
import { ReportDTOTracked, ReportDTOMeta } from "./report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportMetaDTO,
  ReportMetaDTOOptional,
  ReportMetaDTOMetaI,
  ReportMetaDTOTrackedI,
} from "./report-meta-dto";
import { ReportMetaDTOTracked, ReportMetaDTOMeta } from "./report-meta-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportStatus,
  ReportStatusOptional,
  ReportStatusMetaI,
  ReportStatusTrackedI,
} from "./report-status";
import { ReportStatusTracked, ReportStatusMeta } from "./report-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportType,
  ReportTypeOptional,
  ReportTypeMetaI,
  ReportTypeTrackedI,
} from "./report-type";
import { ReportTypeTracked, ReportTypeMeta } from "./report-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportTypeCountDTO,
  ReportTypeCountDTOOptional,
  ReportTypeCountDTOMetaI,
  ReportTypeCountDTOTrackedI,
} from "./report-type-count-dto";
import {
  ReportTypeCountDTOTracked,
  ReportTypeCountDTOMeta,
} from "./report-type-count-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  SignupTypeEnum,
  SignupTypeEnumOptional,
  SignupTypeEnumMetaI,
  SignupTypeEnumTrackedI,
} from "./signup-type-enum";
import { SignupTypeEnumTracked, SignupTypeEnumMeta } from "./signup-type-enum";

/**
 *
 * @export
 * @interface InvalidSignupReportDTO
 */
export interface InvalidSignupReportDTOOptional extends ReportDTOOptional {
  /**
   *
   * @type {boolean}
   * @memberof InvalidSignupReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InvalidSignupReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof InvalidSignupReportDTO
   */
  reportId?: number;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  reportKey?: string;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof InvalidSignupReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof InvalidSignupReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof InvalidSignupReportDTO
   */
  childReports?: ReportDTOOptional[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof InvalidSignupReportDTO
   */
  meta?: ReportMetaDTOOptional[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof InvalidSignupReportDTO
   */
  typeCounts?: ReportTypeCountDTOOptional[];
  /**
   *
   * @type {number}
   * @memberof InvalidSignupReportDTO
   */
  signupId?: number;
  /**
   *
   * @type {number}
   * @memberof InvalidSignupReportDTO
   */
  personId?: number;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  personName?: string;
  /**
   *
   * @type {number}
   * @memberof InvalidSignupReportDTO
   */
  classInstanceId?: number;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  className?: string;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof InvalidSignupReportDTO
   */
  signupType?: SignupTypeEnum;
  /**
   *
   * @type {ProgramTypeEnum}
   * @memberof InvalidSignupReportDTO
   */
  programType?: ProgramTypeEnum;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  validationError?: string;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  classStartDate?: Date;
}

export interface InvalidSignupReportDTO
  extends InvalidSignupReportDTOOptional, ReportDTO {
  /**
   *
   * @type {boolean}
   * @memberof InvalidSignupReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InvalidSignupReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof InvalidSignupReportDTO
   */
  reportId: number;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  reportKey: string;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof InvalidSignupReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof InvalidSignupReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof InvalidSignupReportDTO
   */
  childReports?: ReportDTO[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof InvalidSignupReportDTO
   */
  meta?: ReportMetaDTO[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof InvalidSignupReportDTO
   */
  typeCounts?: ReportTypeCountDTO[];
  /**
   *
   * @type {number}
   * @memberof InvalidSignupReportDTO
   */
  signupId?: number;
  /**
   *
   * @type {number}
   * @memberof InvalidSignupReportDTO
   */
  personId?: number;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  personName?: string;
  /**
   *
   * @type {number}
   * @memberof InvalidSignupReportDTO
   */
  classInstanceId?: number;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  className?: string;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof InvalidSignupReportDTO
   */
  signupType?: SignupTypeEnum;
  /**
   *
   * @type {ProgramTypeEnum}
   * @memberof InvalidSignupReportDTO
   */
  programType?: ProgramTypeEnum;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  validationError?: string;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  classStartDate?: Date;
}

export interface InvalidSignupReportDTOTrackedI extends ReportDTOOptional {
  /**
   *
   * @type {boolean}
   * @memberof InvalidSignupReportDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InvalidSignupReportDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof InvalidSignupReportDTO
   */
  reportId?: number;
  reportIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  reportKey?: string;
  reportKeyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  reportTitle?: string;
  reportTitleIsSet: boolean;
  /**
   *
   * @type {ReportType}
   * @memberof InvalidSignupReportDTO
   */
  reportType?: ReportType;
  reportTypeIsSet: boolean;
  /**
   *
   * @type {ReportStatus}
   * @memberof InvalidSignupReportDTO
   */
  reportStatus?: ReportStatus;
  reportStatusIsSet: boolean;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof InvalidSignupReportDTO
   */
  childReports?: ReportDTOTrackedI[];
  childReportsIsSet: boolean;
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof InvalidSignupReportDTO
   */
  meta?: ReportMetaDTOTrackedI[];
  metaIsSet: boolean;
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof InvalidSignupReportDTO
   */
  typeCounts?: ReportTypeCountDTOTrackedI[];
  typeCountsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof InvalidSignupReportDTO
   */
  signupId?: number;
  signupIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof InvalidSignupReportDTO
   */
  personId?: number;
  personIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  personName?: string;
  personNameIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof InvalidSignupReportDTO
   */
  classInstanceId?: number;
  classInstanceIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  className?: string;
  classNameIsSet: boolean;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof InvalidSignupReportDTO
   */
  signupType?: SignupTypeEnum;
  signupTypeIsSet: boolean;
  /**
   *
   * @type {ProgramTypeEnum}
   * @memberof InvalidSignupReportDTO
   */
  programType?: ProgramTypeEnum;
  programTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  validationError?: string;
  validationErrorIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportDTO
   */
  classStartDate?: Date;
  classStartDateIsSet: boolean;
}

transformDatesMap.set(
  "InvalidSignupReportDTO",
  function (model: InvalidSignupReportDTO) {
    const transformDateschildReports = transformDatesMap.get("ReportDTO");
    if (transformDateschildReports) {
      model.childReports?.forEach((sub) => {
        transformDateschildReports(sub);
      });
    }
    const transformDatesmeta = transformDatesMap.get("ReportMetaDTO");
    if (transformDatesmeta) {
      model.meta?.forEach((sub) => {
        transformDatesmeta(sub);
      });
    }
    const transformDatestypeCounts =
      transformDatesMap.get("ReportTypeCountDTO");
    if (transformDatestypeCounts) {
      model.typeCounts?.forEach((sub) => {
        transformDatestypeCounts(sub);
      });
    }
    if (typeof model.classStartDate == "string")
      model.classStartDate = new Date(model.classStartDate);
  },
);

export type InvalidSignupReportDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  reportId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  reportKey: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportTitle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportType: PropertyMeta<ReportTypeMetaI>;
  //isDate: false
  //isDatetime: false
  reportStatus: PropertyMeta<ReportStatusMetaI>;
  //isDate: false
  //isDatetime: false
  childReports: PropertyMeta<ReportDTOMetaI>;
  //isDate: false
  //isDatetime: false
  meta: PropertyMeta<ReportMetaDTOMetaI>;
  //isDate: false
  //isDatetime: false
  typeCounts: PropertyMeta<ReportTypeCountDTOMetaI>;
  //isDate: false
  //isDatetime: false
  signupId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  personName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  classInstanceId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  className: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  signupType: PropertyMeta<SignupTypeEnumMetaI>;
  //isDate: false
  //isDatetime: false
  programType: PropertyMeta<ProgramTypeEnumMetaI>;
  //isDate: false
  //isDatetime: false
  validationError: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  classStartDate: PropertyMeta<MetaTypeBase<Date>>;
}>;

export var InvalidSignupReportDTOMeta: InvalidSignupReportDTOMetaI =
  {} as InvalidSignupReportDTOMetaI;
InvalidSignupReportDTOMeta = typeMeta("InvalidSignupReportDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  reportId: propertyMeta("reportId", false, true, true, MetaTypesBase.number),
  reportKey: propertyMeta(
    "reportKey",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  reportTitle: propertyMeta(
    "reportTitle",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  reportType: propertyMeta("reportType", false, false, false, ReportTypeMeta),
  reportStatus: propertyMeta(
    "reportStatus",
    false,
    false,
    false,
    ReportStatusMeta,
  ),
  childReports: propertyMeta("childReports", true, false, false, ReportDTOMeta),
  meta: propertyMeta("meta", true, false, false, ReportMetaDTOMeta),
  typeCounts: propertyMeta(
    "typeCounts",
    true,
    false,
    false,
    ReportTypeCountDTOMeta,
  ),
  signupId: propertyMeta("signupId", false, false, false, MetaTypesBase.number),
  personId: propertyMeta("personId", false, false, false, MetaTypesBase.number),
  personName: propertyMeta(
    "personName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  classInstanceId: propertyMeta(
    "classInstanceId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  className: propertyMeta(
    "className",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  signupType: propertyMeta(
    "signupType",
    false,
    false,
    false,
    SignupTypeEnumMeta,
  ),
  programType: propertyMeta(
    "programType",
    false,
    false,
    false,
    ProgramTypeEnumMeta,
  ),
  validationError: propertyMeta(
    "validationError",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  classStartDate: propertyMeta(
    "classStartDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
});

const metaI = InvalidSignupReportDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ReportDTOMeta]);
  metaI.isDeleted.inheritedFrom = ReportDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = ReportDTOMeta.isNew;
  metaI.reportId.inheritedFrom = ReportDTOMeta.reportId;
  metaI.reportKey.inheritedFrom = ReportDTOMeta.reportKey;
  metaI.reportTitle.inheritedFrom = ReportDTOMeta.reportTitle;
  metaI.reportType.inheritedFrom = ReportDTOMeta.reportType;
  metaI.reportStatus.inheritedFrom = ReportDTOMeta.reportStatus;
  metaI.childReports.inheritedFrom = ReportDTOMeta.childReports;
  metaI.meta.inheritedFrom = ReportDTOMeta.meta;
  metaI.typeCounts.inheritedFrom = ReportDTOMeta.typeCounts;
});

export class InvalidSignupReportDTOTracked
  extends ReportDTOTracked
  implements InvalidSignupReportDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  reportId__I?: number = undefined;

  get reportIdIsSet() {
    return this.reportId !== undefined;
  }
  set reportIdIsSet(v: boolean) {}
  set reportId(v: undefined | number) {
    if (v !== undefined) {
      this.reportId__I = v;
      this.reportIdIsSet = true;
    } else {
      this.reportId__I = v || undefined;
      this.reportIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportId() {
    return this.reportId__I;
  }
  reportKey__I?: string = undefined;
  reportKeyIsSet: boolean = false;
  set reportKey(v: undefined | string) {
    if (v !== undefined) {
      this.reportKey__I = v;
      this.reportKeyIsSet = true;
    } else {
      this.reportKey__I = v || undefined;
      this.reportKeyIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportKey() {
    return this.reportKey__I;
  }
  reportTitle__I?: string = undefined;
  reportTitleIsSet: boolean = false;
  set reportTitle(v: undefined | string) {
    if (v !== undefined) {
      this.reportTitle__I = v;
      this.reportTitleIsSet = true;
    } else {
      this.reportTitle__I = v || undefined;
      this.reportTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportTitle() {
    return this.reportTitle__I;
  }
  reportType__I?: ReportType = undefined;
  reportTypeIsSet: boolean = false;
  set reportType(v: undefined | ReportType) {
    if (v !== undefined) {
      this.reportType__I = v;
      this.reportTypeIsSet = true;
    } else {
      this.reportType__I = v || undefined;
      this.reportTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportType() {
    return this.reportType__I;
  }
  reportStatus__I?: ReportStatus = undefined;
  reportStatusIsSet: boolean = false;
  set reportStatus(v: undefined | ReportStatus) {
    if (v !== undefined) {
      this.reportStatus__I = v;
      this.reportStatusIsSet = true;
    } else {
      this.reportStatus__I = v || undefined;
      this.reportStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportStatus() {
    return this.reportStatus__I;
  }
  childReports__I?: ReportDTOTracked[] = undefined;
  childReportsIsSet: boolean = false;
  set childReports(v: undefined | ReportDTOTracked[]) {
    if (v !== undefined) {
      this.childReports__I = v;
      this.childReportsIsSet = true;
    } else {
      this.childReports__I = v || undefined;
      this.childReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get childReports() {
    return this.childReports__I;
  }
  meta__I?: ReportMetaDTOTracked[] = undefined;
  metaIsSet: boolean = false;
  set meta(v: undefined | ReportMetaDTOTracked[]) {
    if (v !== undefined) {
      this.meta__I = v;
      this.metaIsSet = true;
    } else {
      this.meta__I = v || undefined;
      this.metaIsSet = false;
    }
    this.changeTracker = true;
  }
  get meta() {
    return this.meta__I;
  }
  typeCounts__I?: ReportTypeCountDTOTracked[] = undefined;
  typeCountsIsSet: boolean = false;
  set typeCounts(v: undefined | ReportTypeCountDTOTracked[]) {
    if (v !== undefined) {
      this.typeCounts__I = v;
      this.typeCountsIsSet = true;
    } else {
      this.typeCounts__I = v || undefined;
      this.typeCountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeCounts() {
    return this.typeCounts__I;
  }
  signupId__I?: number = undefined;
  signupIdIsSet: boolean = false;
  set signupId(v: undefined | number) {
    if (v !== undefined) {
      this.signupId__I = v;
      this.signupIdIsSet = true;
    } else {
      this.signupId__I = v || undefined;
      this.signupIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupId() {
    return this.signupId__I;
  }
  personId__I?: number = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | number) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  personName__I?: string = undefined;
  personNameIsSet: boolean = false;
  set personName(v: undefined | string) {
    if (v !== undefined) {
      this.personName__I = v;
      this.personNameIsSet = true;
    } else {
      this.personName__I = v || undefined;
      this.personNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get personName() {
    return this.personName__I;
  }
  classInstanceId__I?: number = undefined;
  classInstanceIdIsSet: boolean = false;
  set classInstanceId(v: undefined | number) {
    if (v !== undefined) {
      this.classInstanceId__I = v;
      this.classInstanceIdIsSet = true;
    } else {
      this.classInstanceId__I = v || undefined;
      this.classInstanceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get classInstanceId() {
    return this.classInstanceId__I;
  }
  className__I?: string = undefined;
  classNameIsSet: boolean = false;
  set className(v: undefined | string) {
    if (v !== undefined) {
      this.className__I = v;
      this.classNameIsSet = true;
    } else {
      this.className__I = v || undefined;
      this.classNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get className() {
    return this.className__I;
  }
  signupType__I?: SignupTypeEnum = undefined;
  signupTypeIsSet: boolean = false;
  set signupType(v: undefined | SignupTypeEnum) {
    if (v !== undefined) {
      this.signupType__I = v;
      this.signupTypeIsSet = true;
    } else {
      this.signupType__I = v || undefined;
      this.signupTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupType() {
    return this.signupType__I;
  }
  programType__I?: ProgramTypeEnum = undefined;
  programTypeIsSet: boolean = false;
  set programType(v: undefined | ProgramTypeEnum) {
    if (v !== undefined) {
      this.programType__I = v;
      this.programTypeIsSet = true;
    } else {
      this.programType__I = v || undefined;
      this.programTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get programType() {
    return this.programType__I;
  }
  validationError__I?: string = undefined;
  validationErrorIsSet: boolean = false;
  set validationError(v: undefined | string) {
    if (v !== undefined) {
      this.validationError__I = v;
      this.validationErrorIsSet = true;
    } else {
      this.validationError__I = v || undefined;
      this.validationErrorIsSet = false;
    }
    this.changeTracker = true;
  }
  get validationError() {
    return this.validationError__I;
  }
  classStartDate__I?: Date = undefined;
  classStartDateIsSet: boolean = false;
  set classStartDate(v: undefined | Date) {
    if (v !== undefined) {
      this.classStartDate__I = v;
      this.classStartDateIsSet = true;
    } else {
      this.classStartDate__I = v || undefined;
      this.classStartDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get classStartDate() {
    return this.classStartDate__I;
  }
  constructor(
    config?: InvalidSignupReportDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.reportIdIsSet == true && other?.reportIdIsSet == true)
      return this.reportId == other.reportId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.reportId) {
      this.reportIdIsSet = true;
    }

    this.childReports?.forEach((a) => a.setIds());

    this.meta?.forEach((a) => a.setIds());

    this.typeCounts?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: InvalidSignupReportDTOOptional,
    options?: AssignOptions,
  ): InvalidSignupReportDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.reportId && this.reportIdApplyFilter(optionsRequired.filter)) {
      this.reportId = config.reportId;
      if (optionsRequired.unassign) this.reportIdIsSet = false;
      else this.reportIdIsSet = true;
    }
    if (config.reportKey && this.reportKeyApplyFilter(optionsRequired.filter)) {
      this.reportKey = config.reportKey;
      if (optionsRequired.unassign) this.reportKeyIsSet = false;
      else this.reportKeyIsSet = true;
    }
    if (
      config.reportTitle &&
      this.reportTitleApplyFilter(optionsRequired.filter)
    ) {
      this.reportTitle = config.reportTitle;
      if (optionsRequired.unassign) this.reportTitleIsSet = false;
      else this.reportTitleIsSet = true;
    }
    if (
      config.reportType &&
      this.reportTypeApplyFilter(optionsRequired.filter)
    ) {
      this.reportType = config.reportType;
      if (optionsRequired.unassign) this.reportTypeIsSet = false;
      else this.reportTypeIsSet = true;
    }
    if (
      config.reportStatus &&
      this.reportStatusApplyFilter(optionsRequired.filter)
    ) {
      this.reportStatus = config.reportStatus;
      if (optionsRequired.unassign) this.reportStatusIsSet = false;
      else this.reportStatusIsSet = true;
    }
    if (
      config.childReports &&
      this.childReportsApplyFilter(optionsRequired.filter)
    ) {
      this.childReports = config.childReports?.map(
        (a) => new ReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.childReportsIsSet = false;
      else this.childReportsIsSet = true;
    }
    if (config.meta && this.metaApplyFilter(optionsRequired.filter)) {
      this.meta = config.meta?.map((a) => new ReportMetaDTOTracked(a, options));
      if (optionsRequired.unassign) this.metaIsSet = false;
      else this.metaIsSet = true;
    }
    if (
      config.typeCounts &&
      this.typeCountsApplyFilter(optionsRequired.filter)
    ) {
      this.typeCounts = config.typeCounts?.map(
        (a) => new ReportTypeCountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.typeCountsIsSet = false;
      else this.typeCountsIsSet = true;
    }
    if (config.signupId && this.signupIdApplyFilter(optionsRequired.filter)) {
      this.signupId = config.signupId;
      if (optionsRequired.unassign) this.signupIdIsSet = false;
      else this.signupIdIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = config.personId;
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (
      config.personName &&
      this.personNameApplyFilter(optionsRequired.filter)
    ) {
      this.personName = config.personName;
      if (optionsRequired.unassign) this.personNameIsSet = false;
      else this.personNameIsSet = true;
    }
    if (
      config.classInstanceId &&
      this.classInstanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.classInstanceId = config.classInstanceId;
      if (optionsRequired.unassign) this.classInstanceIdIsSet = false;
      else this.classInstanceIdIsSet = true;
    }
    if (config.className && this.classNameApplyFilter(optionsRequired.filter)) {
      this.className = config.className;
      if (optionsRequired.unassign) this.classNameIsSet = false;
      else this.classNameIsSet = true;
    }
    if (
      config.signupType &&
      this.signupTypeApplyFilter(optionsRequired.filter)
    ) {
      this.signupType = config.signupType;
      if (optionsRequired.unassign) this.signupTypeIsSet = false;
      else this.signupTypeIsSet = true;
    }
    if (
      config.programType &&
      this.programTypeApplyFilter(optionsRequired.filter)
    ) {
      this.programType = config.programType;
      if (optionsRequired.unassign) this.programTypeIsSet = false;
      else this.programTypeIsSet = true;
    }
    if (
      config.validationError &&
      this.validationErrorApplyFilter(optionsRequired.filter)
    ) {
      this.validationError = config.validationError;
      if (optionsRequired.unassign) this.validationErrorIsSet = false;
      else this.validationErrorIsSet = true;
    }
    if (
      config.classStartDate &&
      this.classStartDateApplyFilter(optionsRequired.filter)
    ) {
      this.classStartDate = config.classStartDate;
      if (optionsRequired.unassign) this.classStartDateIsSet = false;
      else this.classStartDateIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): InvalidSignupReportDTOTrackedI {
    const cloned = {} as InvalidSignupReportDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.reportIdIsSetDeep() &&
      this.reportIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportIdIsSet = true;
      cloned.reportId = this.reportId;
    } else {
      //cloned.reportIdIsSet = false
    }
    if (
      this.reportKeyIsSetDeep() &&
      this.reportKeyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportKeyIsSet = true;
      cloned.reportKey = this.reportKey;
    } else {
      //cloned.reportKeyIsSet = false
    }
    if (
      this.reportTitleIsSetDeep() &&
      this.reportTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTitleIsSet = true;
      cloned.reportTitle = this.reportTitle;
    } else {
      //cloned.reportTitleIsSet = false
    }
    if (
      this.reportTypeIsSetDeep() &&
      this.reportTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTypeIsSet = true;
      cloned.reportType = this.reportType;
    } else {
      //cloned.reportTypeIsSet = false
    }
    if (
      this.reportStatusIsSetDeep() &&
      this.reportStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportStatusIsSet = true;
      cloned.reportStatus = this.reportStatus;
    } else {
      //cloned.reportStatusIsSet = false
    }
    if (
      this.childReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.childReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.childReportsIsSet = true;
      cloned.childReports = this.childReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.childReportsIsSet = false
    }
    if (
      this.metaIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.metaApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.metaIsSet = true;
      cloned.meta = this.meta
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.metaIsSet = false
    }
    if (
      this.typeCountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.typeCountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeCountsIsSet = true;
      cloned.typeCounts = this.typeCounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.typeCountsIsSet = false
    }
    if (
      this.signupIdIsSetDeep() &&
      this.signupIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupIdIsSet = true;
      cloned.signupId = this.signupId;
    } else {
      //cloned.signupIdIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId;
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.personNameIsSetDeep() &&
      this.personNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personNameIsSet = true;
      cloned.personName = this.personName;
    } else {
      //cloned.personNameIsSet = false
    }
    if (
      this.classInstanceIdIsSetDeep() &&
      this.classInstanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classInstanceIdIsSet = true;
      cloned.classInstanceId = this.classInstanceId;
    } else {
      //cloned.classInstanceIdIsSet = false
    }
    if (
      this.classNameIsSetDeep() &&
      this.classNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classNameIsSet = true;
      cloned.className = this.className;
    } else {
      //cloned.classNameIsSet = false
    }
    if (
      this.signupTypeIsSetDeep() &&
      this.signupTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupTypeIsSet = true;
      cloned.signupType = this.signupType;
    } else {
      //cloned.signupTypeIsSet = false
    }
    if (
      this.programTypeIsSetDeep() &&
      this.programTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.programTypeIsSet = true;
      cloned.programType = this.programType;
    } else {
      //cloned.programTypeIsSet = false
    }
    if (
      this.validationErrorIsSetDeep() &&
      this.validationErrorApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.validationErrorIsSet = true;
      cloned.validationError = this.validationError;
    } else {
      //cloned.validationErrorIsSet = false
    }
    if (
      this.classStartDateIsSetDeep() &&
      this.classStartDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classStartDateIsSet = true;
      cloned.classStartDate = this.classStartDate;
    } else {
      //cloned.classStartDateIsSet = false
    }
    if (!isDeleted(this) && !this.reportIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): InvalidSignupReportDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.reportIdApplyFilter(filter)) this.reportIdIsSet = false;

    if (!this.reportKeyApplyFilter(filter)) this.reportKeyIsSet = false;

    if (!this.reportTitleApplyFilter(filter)) this.reportTitleIsSet = false;

    if (!this.reportTypeApplyFilter(filter)) this.reportTypeIsSet = false;

    if (!this.reportStatusApplyFilter(filter)) this.reportStatusIsSet = false;

    if (!this.childReportsApplyFilter(filter)) this.childReportsIsSet = false;

    this.childReports?.forEach((a) => a.unassignAll(filter));
    if (!this.metaApplyFilter(filter)) this.metaIsSet = false;

    this.meta?.forEach((a) => a.unassignAll(filter));
    if (!this.typeCountsApplyFilter(filter)) this.typeCountsIsSet = false;

    this.typeCounts?.forEach((a) => a.unassignAll(filter));
    if (!this.signupIdApplyFilter(filter)) this.signupIdIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;

    if (!this.personNameApplyFilter(filter)) this.personNameIsSet = false;

    if (!this.classInstanceIdApplyFilter(filter))
      this.classInstanceIdIsSet = false;

    if (!this.classNameApplyFilter(filter)) this.classNameIsSet = false;

    if (!this.signupTypeApplyFilter(filter)) this.signupTypeIsSet = false;

    if (!this.programTypeApplyFilter(filter)) this.programTypeIsSet = false;

    if (!this.validationErrorApplyFilter(filter))
      this.validationErrorIsSet = false;

    if (!this.classStartDateApplyFilter(filter))
      this.classStartDateIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.isDeleted,
      InvalidSignupReportDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.isNew,
      InvalidSignupReportDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  reportIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.reportId,
      InvalidSignupReportDTOMeta,
      this.reportId,
      this,
    );
  }
  reportIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportIdIsSet && this.reportIdApplyFilter(filter)) return true;

    return false;
  }
  reportKeyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.reportKey,
      InvalidSignupReportDTOMeta,
      this.reportKey,
      this,
    );
  }
  reportKeyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportKeyIsSet && this.reportKeyApplyFilter(filter)) return true;

    return false;
  }
  reportTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.reportTitle,
      InvalidSignupReportDTOMeta,
      this.reportTitle,
      this,
    );
  }
  reportTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTitleIsSet && this.reportTitleApplyFilter(filter))
      return true;

    return false;
  }
  reportTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.reportType,
      InvalidSignupReportDTOMeta,
      this.reportType,
      this,
    );
  }
  reportTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTypeIsSet && this.reportTypeApplyFilter(filter)) return true;

    return false;
  }
  reportStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.reportStatus,
      InvalidSignupReportDTOMeta,
      this.reportStatus,
      this,
    );
  }
  reportStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportStatusIsSet && this.reportStatusApplyFilter(filter))
      return true;

    return false;
  }
  childReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.childReports,
      InvalidSignupReportDTOMeta,
      this.childReports,
      this,
    );
  }
  childReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.childReportsIsSet && this.childReportsApplyFilter(filter))
      return true;

    return this.childReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  metaApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.meta,
      InvalidSignupReportDTOMeta,
      this.meta,
      this,
    );
  }
  metaIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.metaIsSet && this.metaApplyFilter(filter)) return true;

    return this.meta?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  typeCountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.typeCounts,
      InvalidSignupReportDTOMeta,
      this.typeCounts,
      this,
    );
  }
  typeCountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeCountsIsSet && this.typeCountsApplyFilter(filter)) return true;

    return this.typeCounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  signupIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.signupId,
      InvalidSignupReportDTOMeta,
      this.signupId,
      this,
    );
  }
  signupIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupIdIsSet && this.signupIdApplyFilter(filter)) return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.personId,
      InvalidSignupReportDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;

    return false;
  }
  personNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.personName,
      InvalidSignupReportDTOMeta,
      this.personName,
      this,
    );
  }
  personNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personNameIsSet && this.personNameApplyFilter(filter)) return true;

    return false;
  }
  classInstanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.classInstanceId,
      InvalidSignupReportDTOMeta,
      this.classInstanceId,
      this,
    );
  }
  classInstanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classInstanceIdIsSet && this.classInstanceIdApplyFilter(filter))
      return true;

    return false;
  }
  classNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.className,
      InvalidSignupReportDTOMeta,
      this.className,
      this,
    );
  }
  classNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classNameIsSet && this.classNameApplyFilter(filter)) return true;

    return false;
  }
  signupTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.signupType,
      InvalidSignupReportDTOMeta,
      this.signupType,
      this,
    );
  }
  signupTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupTypeIsSet && this.signupTypeApplyFilter(filter)) return true;

    return false;
  }
  programTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.programType,
      InvalidSignupReportDTOMeta,
      this.programType,
      this,
    );
  }
  programTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.programTypeIsSet && this.programTypeApplyFilter(filter))
      return true;

    return false;
  }
  validationErrorApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.validationError,
      InvalidSignupReportDTOMeta,
      this.validationError,
      this,
    );
  }
  validationErrorIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.validationErrorIsSet && this.validationErrorApplyFilter(filter))
      return true;

    return false;
  }
  classStartDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportDTOMeta.classStartDate,
      InvalidSignupReportDTOMeta,
      this.classStartDate,
      this,
    );
  }
  classStartDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classStartDateIsSet && this.classStartDateApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.reportIdIsSetDeep(filter)) return true;
    if (this.reportKeyIsSetDeep(filter)) return true;
    if (this.reportTitleIsSetDeep(filter)) return true;
    if (this.reportTypeIsSetDeep(filter)) return true;
    if (this.reportStatusIsSetDeep(filter)) return true;
    if (this.childReportsIsSetDeep(filter)) return true;
    if (this.metaIsSetDeep(filter)) return true;
    if (this.typeCountsIsSetDeep(filter)) return true;
    if (this.signupIdIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.personNameIsSetDeep(filter)) return true;
    if (this.classInstanceIdIsSetDeep(filter)) return true;
    if (this.classNameIsSetDeep(filter)) return true;
    if (this.signupTypeIsSetDeep(filter)) return true;
    if (this.programTypeIsSetDeep(filter)) return true;
    if (this.validationErrorIsSetDeep(filter)) return true;
    if (this.classStartDateIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
